export const USER_SETTINGS_FEATURES = {
  enablesales: {
    id: 'enablesales',
    label: 'label.SALES_PRODUCTS',
    description: 'label.TOOLTIP.SALES_PRODUCTS'
  },
  autotrackemails: {
    id: 'autotrackemails',
    label: 'label.AUTO_TRACK_EMAILS',
    description: 'label.TOOLTIP.AUTO_TRACK_EMAILS'
  },
  autotracklinks: {
    id: 'autotracklinks',
    label: 'label.AUTO_TRACK_LINKS',
    description: 'label.TOOLTIP.AUTO_TRACK_LINKS'
  },
  autotrackdocs: {
    id: 'autotrackdocs',
    label: 'label.AUTO_TRACK_ATTACHMENTS',
    description: 'label.TOOLTIP.AUTO_TRACK_ATTACHMENTS'
  },
  attsattop: {
    id: 'attsattop',
    label: 'label.ATTACHMENTS_AT_TOP',
    description: 'label.TOOLTIP.ATTACHMENTS_AT_TOP'
  },
  usequickhash: {
    id: 'usequickhash',
    label: 'label.USE_##_SHORTCUT',
    description: 'label.TOOLTIP.USE_##_SHORTCUT'
  },
  autobcc: {
    id: 'autobcc',
    label: 'label.AUTO_BCC',
    description: 'label.TOOLTIP.AUTO_BCC',
    placeholder: '12345@bcc.hubspot.com'
  },
  trackautobcc: {
    id: 'trackautobcc',
    label: 'label.TRACK_AUTO_BCC',
    description: 'label.TOOLTIP.TRACK_AUTO_BCC'
  },
  donottrack: {
    id: 'donottrack',
    label: 'label.DO_NOT_TRACK_LIST',
    description: 'label.TOOLTIP.DO_NOT_TRACK_LIST',
    placeholder: ''
  },
  trackautoforwards: {
    id: 'trackautoforwards',
    label: 'label.TRACK_AUTO_FORWARDED_EMAILS',
    description: 'label.TOOLTIP.TRACK_AUTO_FORWARDED_EMAILS'
  },
  enabletiming: {
    id: 'enabletiming',
    label: 'label.DWELL_TIME_BETA',
    description: 'label.TOOLTIP.DWELL_TIME_BETA'
  },
  disablefeed: {
    id: 'disablefeed',
    label: 'label.DISABLE_SMART_FEED',
    description: 'label.TOOLTIP.SMART_ACTIVITY_FEED'
  },
  enableatticon: {
    id: 'enableatticon',
    label: 'label.ATTACHMENT_ICON',
    description: 'label.TOOLTIP.ATTACHMENT_ICON'
  },
  keepattachments: {
    id: 'keepattachments',
    label: 'label.KEEP_ORIGINAL_ATTACHMENTS',
    description: 'label.TOOLTIP.KEEP_ORIGINAL_ATTACHMENTS'
  },
  disablesplitsend: {
    id: 'disablesplitsend',
    label: 'label.DISABLE_MULTI_RECIPIENT_PROCESSING',
    description: 'label.TOOLTIP.MULTI_RECIPIENT_TRACKING'
  }
};
